import { Header, Icon, Segment } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import { db, firebase } from "astrid-firebase";
import updateDocument from "astrid-firestore/src/helpers/updateDocument";
import { getUserRef } from "astrid-firestore/src/utils/referenceMappers";
import { getCountryName } from "astrid-helpers/src/countries";

import Flex from "../../../../../components/Flex/Flex";
import { useProfile } from "../../../../authentication/state/profile";
import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";

export default function OrderEmailForm({ organization, order, onClose }) {
	const { t } = useTranslation();
	const user = useProfile();

	const { form, onSubmit, error } = useSimpleForm({
		defaultValues: {
			recipient: organization.financeEmail || "",
			subject: `New Earselect Sales Order - ${order.secondParty.name} - ${order.id}`,
			body: `New sales order for Earselect - ${order.secondParty.name} - ${order.id}

Created Date: ${order.created.toDate().toLocaleDateString()}
Created By: ${order.createdBy?.name}

Total: ${order.total}
Currency: ${order.currency}

Recipient:
${order.secondParty.vendor.name} (${order.secondParty.vendor.organizationNumber})
${order.secondParty.vendor.street}
${order.secondParty.vendor.zip} ${order.secondParty.vendor.city}
${getCountryName(order.secondParty.vendor.country)}
${order.secondParty.vendor.phone}

`,
		},
		onSubmit: async ({ recipient, subject, body }) => {
			await db.collection("notifications").add({
				to: { email: recipient },
				subject,
				message: body,
				time: firebase.firestore.FieldValue.serverTimestamp(),
				sendOnStage: true,
				attachments: [
					{ name: order.excel.name, path: `gs://${order.excel.bucket}/${order.excel.fullPath}` },
					{ name: order.pdf.name, path: `gs://${order.pdf.bucket}/${order.pdf.fullPath}` },
				],
			});

			if (!order.processed || window.confirm(t("sureSetUnprocessed"))) {
				updateDocument(order.ref, {
					processed: !order.processed,
					processedBy: getUserRef(user),
					processedAt: firebase.firestore.FieldValue.serverTimestamp(),
				});
			}

			onClose();
		},
	});

	return (
		<Form.Modal
			header={t("emailToFinance", "Email to finance")}
			size="tiny"
			form={form}
			error={error}
			submitText={t("sendEmail", "Send email")}
			onSubmit={onSubmit}
			onClose={onClose}
		>
			<Form.Input name="recipient" label={t("recipient", "Recipient")} />

			<Form.Input name="subject" label={t("subject", "Subject")} />

			<Form.TextArea name="body" label={t("body", "Body")} style={{ fieldSizing: "content" }} />

			<Header style={{ fontSize: 13 }}>Files</Header>

			<Flex gap={10}>
				<File
					name={order.excel?.name}
					icon="file excel"
					onClick={() => window.open(order.excel?.url, "_blank")}
				/>

				<File name={order.pdf?.name} icon="file pdf" onClick={() => window.open(order.pdf?.url, "_blank")} />
			</Flex>
		</Form.Modal>
	);
}

function File({ name, icon, onClick }) {
	return (
		<Segment style={{ flex: 1, margin: 0, cursor: "pointer" }} onClick={onClick}>
			<Flex justifyContent="flex-start">
				<div>
					<Icon name={icon} style={{ fontSize: 18 }} />
				</div>

				<p>{name}</p>
			</Flex>
		</Segment>
	);
}
